import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NgModel, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[gripComparePassword]',
    providers: [{
            provide: NG_VALIDATORS,
            useExisting: DifferentPasswordValidatorDirective,
            multi: true
        }],
    standalone: false
})

export class DifferentPasswordValidatorDirective implements Validator {

  @Input() gripComparePassword: NgModel | null = null;

  validate(control: AbstractControl): ValidationErrors | null {
    if(this.gripComparePassword?.control.value === control.value){
      return {
        samePassword: true
      }
    }
    return null;
  }
}
